import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import allActions from '../../actions/index';

function MobileBottomAds() {    
    var BottomADV = "";

    const mobile_bottom = useSelector((state) => state.HomeBucket.bucket.data.ads.mobile_bottom);
    const dispatch = useDispatch();

    function openModal() {
       dispatch( allActions.ModalPopup.showPopupByPopupName({ popupname:mobile_bottom.popupname}));
    }

    if(mobile_bottom.popupname){
        BottomADV = () => <button onClick={() => openModal()}><div dangerouslySetInnerHTML={{__html: mobile_bottom.data}} /></button>
     }else{
        BottomADV = () => <div dangerouslySetInnerHTML={{__html: mobile_bottom.data}} />
     }

    /******get data from localstorage*******/
    let authlogin = localStorage.getItem('authlogin');
    let storageDataAuthLogin = authlogin ? JSON.parse(authlogin) : "";
    var initialUsername = storageDataAuthLogin ? storageDataAuthLogin.user_email :  "";

     if(initialUsername==="vip@ciisummit.com" || initialUsername==="VIP@CIISUMMIT.COM"){
        BottomADV = () => <img src="https://community-wp.ciisummit.com/wp-content/uploads/2022/09/top-banner.jpg"></img>;
      }

    return (
    <>
    <div className="mobile-bottom-ads-section mobile-screen-show">

        <BottomADV />

        {/* <ModalPopup modalIsOpen={modalIsOpen} whichModal={mobile_bottom.popup} onCloseModal={() => closeModal()}/> */}

    </div>
    </>
    );
}

  
  
  export default MobileBottomAds;